export class FormOther {
  constructor() {
    if (document.querySelector('.c-form') === null) return
    const otherInput = document.querySelectorAll('.js-other_input')
    const otherInputArr = Array.prototype.slice.call(otherInput, 0)
    const otherCheck = document.querySelectorAll('.js-other_check')
    const otherCheckArr = Array.prototype.slice.call(otherCheck, 0)
    otherInputArr.forEach(function (target) {
      target.disabled = true
    })

    otherCheckArr.forEach(function (target) {
      let otherInputElm = target.querySelector('.js-other_input')

      let radioArr = target.querySelectorAll(`input[type='radio']`)
      radioArr.forEach(function (el) {
        el.addEventListener('change', (event) => {
          let $this = event.currentTarget
          if (el.value === 'other') {
            otherInputElm.disabled = false
          } else {
            otherInputElm.disabled = true
          }
        })
      })
    })
  }
}
